import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "urgentp",
  "use": "urgentp-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"urgentp\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.528 2.283a3 3 0 0 1 4.037 1.058l.003.005 8.47 14.14.008.014a3 3 0 0 1-2.565 4.5H3.519a3 3 0 0 1-2.565-4.5l.008-.014 8.47-14.14.858.514-.855-.519a3 3 0 0 1 1.093-1.058zm.618 2.094L2.683 18.506A1 1 0 0 0 3.536 20h16.928a1 1 0 0 0 .853-1.494L12.855 4.379l-.001-.002a1 1 0 0 0-1.708 0z\" fill=\"#FFF\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 8a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1zM11 17a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1z\" fill=\"#FFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./icons/urgentp.svg
// module id = 470
// module chunks = 0